module.exports = __webpack_public_path__ + "img/contact-logo.b38639e0.png";